import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageWidgetBlueprint } from '@backstage/plugin-home-react/alpha';
import { MarkdownContent } from '@backstage/core-components';

const content = `
## Engineering workspace

Use this internal workspace to find THiNK systems, software, APIs, and
technical documentation. Search the engineering estate, then register a
service with repository-owned metadata when it is ready.

### Work with the platform

- [Browse the software catalog](/catalog)
- [Explore APIs](/catalog?filters[kind]=api)
- [Read technical documentation](/docs)
- [Register an existing THiNK service](/create)
- [Search the engineering estate](/search)

### Ownership model

The central platform repository governs domains, systems, groups, and shared
conventions. Each software repository increasingly owns its own
\`catalog-info.yaml\`, API definitions, and TechDocs.
`;

const gettingStartedWidget = HomePageWidgetBlueprint.make({
  name: 'getting-started',
  params: {
    name: 'GettingStarted',
    title: 'THiNK Engineering',
    description: 'Find, understand, and register engineering services',
    components: async () => ({
      Content: () => <MarkdownContent content={content} />,
    }),
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [gettingStartedWidget],
});
